<template>
  <div class="grap-pdf">
    <div>
      <Common v-on:loaded="onLoaded" :isShow='false'/>
    </div>
    <div class="page">
      <Chart :totalPage="totalPage"/>
    </div>
  </div>
</template>
<script>
  import Common from './Common'
  import Chart from './Chart'
  import { mapState } from 'vuex'
  import font from '@/pdffont/font.js'
  export default {
    components: {
      Common,
      Chart
    },
    data() {
      return {
        totalPage: 2,
        displayType: [this.$t('by_day'), this.$t('by_week'), this.$t('by_month')],
        filterType: [
          this.$t('one_day'), 
          this.$t('one_week'), 
          this.$t('one_month'), 
          this.$t('three_months'), 
          this.$t('six_months'), 
          this.$t('one_year'), 
          this.$t('three_year'),
          this.$t('five_year'),
          this.$t('all_periods')
        ],
      }
    },
    computed: {
      ...mapState({
        info: state => state.patient.info,
        pdf: state => state.patient.pdf
      }),
    },
    mounted() {
      this.setMarginCenter("main-pdf", "page")
    },
    methods: {
      onLoaded(totalPage) {
        this.totalPage += totalPage
        this.updatePageNumber()
        this.exportPDF()
      },
      async exportPDF() {
        const KidNickname = this.pdf.child_name
        const currentDate = this.pdf.dateEnd.split('/').join('')
        const displayPeriod = this.filterType[this.pdf.filterTypeActive]
        const displayUnit = this.displayType[this.pdf.displayTypeActive]

        let fileName = 'nanacara_' + currentDate + '_' + KidNickname + '_' + displayPeriod + '_' + displayUnit;
        var pdf = new jsPDF({
          orientation: 'p',
          unit: 'pt',
          format: 'a4',
        });

        var barChart = document.getElementById('bar-chart');
        var pages =  document.getElementsByClassName('grap-pdf')[0].children;

        setTimeout(async () => {
          await html2canvas(
            barChart,
            {
              letterRendering: true,
              height : 300,
              width : 754,
              dpi: 300,
            }
          ).then(function(canvas) {
            var ctx = canvas.getContext('2d');
            ctx.webkitImageSmoothingEnabled = false;
            ctx.mozImageSmoothingEnabled = false;
            ctx.imageSmoothingEnabled = false;
            const dataURL = canvas.toDataURL('image/png', 1);

            var charJS = document.getElementById('chart-js');
            var img = document.createElement("img");
            img.src = dataURL;
            img.style.height = '100%';
            img.style.width = '100%';
            charJS.replaceChild(img, barChart);
          });

          pdf.addFileToVFS( 'SourceHanSansCN-Normal-normal.ttf', font );
          pdf.addFont('SourceHanSansCN-Normal-normal.ttf', 'SourceHanSansCN-Normal', 'normal');
          pdf.setFont( 'SourceHanSansCN-Normal', 'normal' );

          for (let index = 1; index < pages.length; index++) {
            await pdf.addPage();
            var element = pages[index];
            element.style.fontFamily = 'SourceHanSansCN-Normal';
            await pdf.html(element, {
                callback: function ( newPdf ) {
                  return newPdf;
                },
                html2canvas : {
                  scale : 0.74,
                },
                margin: [0, 0, 0, 4],
                x: 0,
                y: pdf.internal.pageSize.getHeight() * (index - 1),
            })
            element.style.fontFamily = 'inherit';
          }

          let pageCount = pdf.internal.getNumberOfPages();
          pdf.deletePage(pageCount)
          pdf.save(fileName);
        }, 5000)
        
      },
      setMarginCenter(containerName, pageName) {
        var marginLeft = Math.round((document.body.clientWidth - document.getElementsByClassName(pageName)[0].clientWidth) / 2)
        document.getElementById(containerName).style.marginLeft = marginLeft+"px"
      },
      updatePageNumber() {
        let listPageHeader = document.querySelectorAll('.fRight')
        listPageHeader.forEach((el, index) => {
          el.innerHTML = this.$t('output_date_and_time') + this.pdf.currentDateTime +"&emsp;"+ (index+1) +"/"+ listPageHeader.length
        })
      }
    }
  }
</script>
